import Page from "~/components/Page";
import OrderDetails from "~/components/orderDetails/OrderDetails";

export default function OrderPage() {
  return (
    <Page title="Orden de compra | Shop Story">
      <OrderDetails />
    </Page>
  );
}
